import { memo } from 'react';

import { Info } from '@air/next-icons';
import { Tooltip } from '@air/primitive-tooltip';

type PermissionToggleInfoProps = {
  text: string;
  className?: string;
};

export const PermissionToggleInfo = memo(({ text, className }: PermissionToggleInfoProps) => (
  <Tooltip label={text} className={className}>
    <Info className="size-4 text-grey-10" />
  </Tooltip>
));

PermissionToggleInfo.displayName = 'PermissionToggleInfo';
